import { SankeyData, SankeyLinkData, SankeyScalingOptions } from '../../types/visualization';

function computeMaxLinkValue(links: SankeyLinkData[]): number {
  return links.reduce((max, link) => (link.value > max ? link.value : max), 0);
}

export function scaleSankeyData(
  data: SankeyData,
  options: SankeyScalingOptions = {}
): SankeyData {
  if (!data.links.length) return data;

  const maxValue = computeMaxLinkValue(data.links);
  if (maxValue === 0) return data;

  // Choose sensible defaults for very small datasets so visuals remain legible
  const dynamicDefaults = (() => {
    if (maxValue <= 3) {
      // Very sparse: keep thin but visible and avoid oversized scaling
      return { minVisibleValue: 2, normalizeMaxTo: 6 };
    }
    if (maxValue <= 10) {
      return { minVisibleValue: 3, normalizeMaxTo: 12 };
    }
    return { minVisibleValue: 2, normalizeMaxTo: 20 };
  })();

  const minVisibleValue = options.minVisibleValue ?? dynamicDefaults.minVisibleValue!;
  const normalizeMaxTo = options.normalizeMaxTo ?? dynamicDefaults.normalizeMaxTo!;

  const scale = normalizeMaxTo / maxValue;

  const scaledLinks = data.links.map((link) => {
    const originalValue = link.originalValue ?? link.value; // Preserve original if already set
    const scaled = link.value * scale;
    const clamped = scaled < minVisibleValue && link.value > 0 ? minVisibleValue : scaled;
    return { ...link, value: clamped, originalValue }; // Store original value for display
  });

  return {
    nodes: data.nodes,
    links: scaledLinks,
  };
}

export function hasAnyPositiveLink(data: SankeyData): boolean {
  return data.links.some((l) => l.value > 0);
}


